module.exports = __webpack_public_path__ + "img/e463db5ab162e92fd3ffcbd8ccc8d9f9.svg";